import { marked } from "marked";
import { init, init1, audio } from "@/api/index";
import { fetchEventSource } from "@microsoft/fetch-event-source";
export default {
  data() {
    return {
      audioObj: null,
      flags: false,
      plays: null,
      countdown: 30,
      timer:null,
      headerText:'请以诗人的口吻回答：',
      bottomText:'。 回复内尽量精简，不超过60个字。',
      lodding:false,
      signSucc:null
    };
  },
  computed: {
    markdownToHtml() {
      return marked(this.message);
    },
    nr() {
      return function (val) {
        return marked(val);
      };
    },
    filtration() {
      return function(text){
        return this.headerText?text.split(this.headerText)[1].split(this.bottomText)[0]:text.split(this.bottomText)[0]
      }
    },
  },
  mounted() {
    this.audioObj = new Audio()
    document.addEventListener('contextmenu', function (e) {
        e.preventDefault();
    });

    document.addEventListener('selectstart', function (e) {
        e.preventDefault();
    });
  },
  methods: {
    searchKeys(arr) {
      var str = "";
      var list = [];
      for (var i = 0; i < arr.length; i++) {
        var hasRead = false;
        for (var k = 0; k < list.length; k++) {
          if (list[k].role == arr[i].role) {
            hasRead = true;
          }
        }
        if (!hasRead) {
          var _index = i,
            haveSame = false;
          for (var j = i + 1; j < arr.length; j++) {
            if (arr[i].role == arr[j].role) {
              _index += "," + j;
              haveSame = true;
            }
          }
          if (haveSame) {
            // list.push(arr[i].role);
            str = "数组下标为" + _index + "，相同值为" + arr[i].role + "\n";
          }
        }
      }
      return str;
    },
    //帮助
    help() {
      this.maskFlag = true;
      try {
        if (this.signSucc) {
          if (this.plays) {
            this.plays.then((res) => {
              this.signSucc.pause();
            });
          }
        }
      } catch (error) {
        console.log(error, "error");
      }
    },
    okBtn() {
      this.maskFlag = false;
    },

    //询问
    ask() {
      // this.audioInit()
      if (this.flags) {
        return;
      }
      clearInterval(this.timer)
      console.log("aaa");
      this.timer=null
      this.countdown = 30;
      this.content = "";
      try {
        if (this.signSucc) {
          if (this.plays) {
            this.plays.then((res) => {
              this.signSucc.pause();
            });
          }
        }
      } catch (e) {}

      this.flag = true;
    },
    cancelBtn() {
      this.flag = false;
      this.content = "";
      console.log('清空timer',this.timer);
      clearInterval(this.timer);
      this.$refs.endBtn.click();
    },
    //确定
    confirmBtn() {
      this.flag = false;
      if (!this.content) {
        return;
      }
      this.lodding=true
      this.flags = true;
      console.log('清空timer',this.timer);
      clearInterval(this.timer);
      console.log("##", "流程开始", this.flags, this.content);
      this.source();
    },
    //清除记录
    clearHistory() {
      if (this.prompt.length % 2 == 0) {
        this.prompt = [];
      } else {
        this.prompt.splice(0, this.prompt.length - 1);
      }
    },
    //取消
    paused() {
      if (this.signSucc) {
        if (this.plays) {
          this.plays.then((res) => {
            this.signSucc.pause();
          });
        }
      }
      clearInterval(this.timer)
      this.flags = false;
    },

    //流式输出
    source() {
      let that = this;

      that.message = "";
      const pattern = /\[.*?\]/;
      if (pattern.test(that.message)) {
        that.prompt.splice(0, that.prompt.length - 2);
      }

      that.prompt.push({
        role: "user",
        content:that.headerText+
          that.content +
         that.bottomText,
      });
      // that.prompt.push({
      //   role: "user",
      //   content:'网络安全为人民，网络安全靠人民。欢迎来到中山市网络安全体验展，本次体验展是由广东省委网信办统一部署，中市委网信办创新谋划打造，旨在深入宣传展示网络安全科普知识，向全市广大市民群众提供一个沉浸式学习体验场景。我是讲解员“小布哥”，我能为大家个绍体验展的相关情况，告诉大家哪里可以学到最实用的网络安全小知识、哪里可以体验到有趣的人工智能新技术。同时，我也是一位网络安全小专家哦，期待能与大家一同分享和学习更多网络安全知识。网络安全体验区 第二个分区是“网络安全发展脉络区”，这里系统展示互联网从诞生到现在的发展历程，包括重要的技术突破和网络发展标志性事件。在这里，您可以了解到网络安全从无到有、从简单到复杂、从单一到多维的发展趋势。第三个分区是“数据安全和个人信息保护区”。这个区域将介绍如何做好个人信息安全保护、防止数据泄露等。通过各种场景演示和实例宣传，在体验中提高个人信息自我保护的意识和能力。第四个分区是“物联网技术互动区”。这里将会通过有趣的互动展示与联网与物联网等技术如何推动和影响我们的工作生活，同时也引发我们对技术应用可能带来潜在网络安全威胁的思考。第五个分区是“新技术体验区”。在这里您将接触到包括人工智能、VR、AR等前沿技术，您可以与人工智能进行文本对话交互，也可以感受虚拟现实的视觉体验，还可以参观网络安全AI主题画展。第六个分区是“网络文明专区”。这个区域包括对网络文明理念的宣传、对网络文明知识的普及，提醒我们要养成良好上网习惯，共同营造良好的网络环境。第七个分区是“反诈宣传专区”，这里将会通过各种案例和宣传互动，让您识破各种网络诈骗手段，不断提高我们的网络反诈意识。以上是本次网络安全体验展的基本内容，期待您在这次体验展中收获对网络安全更多更深入的知识，愿大家共建共享和谐网络空间，齐心推动互联网技术不断造福于我们的生活。假如你现在是展会讲解员，如果上文中有相关内容，请根据内容讲解。 不要出现“根据提供的信息”的相关字眼。问题如下：'+
      //     that.content +
      //     '。 回复内尽量精简，不超过60个字。',
      // });

      const OPENAI_API_KEY1 =
        "eyJhbGciOiJIUzI1NiIsInNpZ25fdHlwZSI6IlNJR04iLCJ0eXAiOiJKV1QifQ.eyJhcGlfa2V5IjoiZDljOTRiODQ0OWRkYzEyZjY0ZGU3NDc4Njk0NTNjOTkiLCJleHAiOjE2OTczMzA1NTcwOTYsInRpbWVzdGFtcCI6MTY5MTk3Mzc1NzA5Nn0.TmsYUHVYGR8slGadI7QqJ53kEa2X4H2xIm5kicGCNoY";
      const OPENAI_COMPLETION_ENDPOINT =
        "https://open.bigmodel.cn/api/paas/v3/model-api/chatglm_pro/sse-invoke";
      var request_data = [];
      request_data[0] = that.prompt[that.prompt.length - 1];
      const requestData = {
        prompt: request_data,
      };
      fetchEventSource(OPENAI_COMPLETION_ENDPOINT, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${OPENAI_API_KEY1}`,
        },
        body: JSON.stringify(requestData),
        async onopen(response) {
          console.log("##", "流式开始", that.flags);
          console.log(response, "response");
          if (
            response.ok &&
            response.headers.get("content-type") === "text/event-stream"
          ) {
          } else if (
            response.status >= 400 &&
            response.status < 500 &&
            response.status !== 429
          ) {
          } else {
          }
        },
        onmessage(msg) {
          that.content = "";
          that.message += msg.data;
          that.event = msg.event;
          let container =
            document.querySelector(".rowy") || document.querySelector(".main");
          setTimeout(() => {
            container.scrollTop = container.scrollHeight;
          });

          if (msg.event != "add") {
            that.aa = true;
            if (that.message) {
              that.prompt.push({
                role: "assistant",
                content: that.message,
                
              });
              audio(that.message, "zh-CN-XiaoxiaoNeural").then((res) => {
                if(res.resultData.data.playtime_seconds<=0){
                  that.lodding=false
                  that.flag=false
                  that.flags = false;
                  return
                }
                that.isShow=false
                console.log(res, 6999);
                // that.flag=false
                 that.playTimers=setInterval(()=>{
                    clearInterval(that.playTimers)
                    that.signSucc = that.audioObj;
                    that.signSucc.src = res.resultData.data.url2;
                    console.log("##", "audio播放器更换URL", that.signSucc.src);
                    
                    if (!that.signSucc.src) return;
                    that.plays = that.signSucc.play();
                  // that.$set(that,'videoSrcs',res.resultData.data.url3)
                  console.log("##", "video播放器更换URL", that.videoSrc);
                  console.log(that.signSucc, that.plays, "that.signSucc");
                  that.lodding=false
                  that.flag=false
                  that.flags = false;
                    that.signSucc.addEventListener('ended',function () {
                    console.log('audio结束');
                    },false)
                 },1000)
                  
              });
  

            }
          }
        },
        onclose() {},
        onerror(err) {
        
          console.log("error", err);
        },
      });
    },
    //语音转文字
    audioInit() {
      let that = this;
      console.log(77);
      // 初始化语音转写
      let startBtn = document.getElementById("startBtn");
      // 结束按钮
      let endBtn = document.getElementById("endBtn");
      console.log(startBtn, endBtn);
      // 接收识别的文本
      let output = document.getElementById("output");
      // 记时器
      let time = document.getElementById("time");
      // 如果使用的是webpack,或者报错 请尝试这种写法  const recorderWorker = new Worker('../assets/js/transformpcm.worker.js')
      const recorderWorker = new Worker(
        new URL("@/assets/js/transformpcm.worker.js", import.meta.url)
      );
      // 记录处理的缓存音频
      let buffer = [];
      let AudioContext = window.AudioContext || window.webkitAudioContext;
      navigator.getUserMedia =
        navigator.getUserMedia ||
        navigator.webkitGetUserMedia ||
        navigator.mozGetUserMedia ||
        navigator.msGetUserMedia;

      recorderWorker.onmessage = function (e) {
        buffer.push(...e.data.buffer);
      };

      class IatRecorder {
        constructor(config) {
          this.config = config;
          this.state = "ing";

          //以下信息在控制台-我的应用-实时语音转写 页面获取
          this.appId = "7734097b";
          this.apiKey = "78d0ca7b22f6dc8131f4b30765e0048b";
        }

        start() {
          console.log(111);
          this.stop();
          if (navigator.getUserMedia && AudioContext) {
            this.state = "ing";
            if (!this.recorder) {
              var context = new AudioContext();
              this.context = context;
              this.recorder = context.createScriptProcessor(0, 1, 1);

              var getMediaSuccess = (stream) => {
                var mediaStream = this.context.createMediaStreamSource(stream);
                this.mediaStream = mediaStream;
                this.recorder.onaudioprocess = (e) => {
                  this.sendData(e.inputBuffer.getChannelData(0));
                };
                console.log(111);
                this.connectWebsocket();
              };
              var getMediaFail = (e) => {
                this.recorder = null;
                this.mediaStream = null;
                this.context = null;
                console.log("请求麦克风失败");
                alert("请求麦克风失败");
              };
              if (
                navigator.mediaDevices &&
                navigator.mediaDevices.getUserMedia
              ) {
                navigator.mediaDevices
                  .getUserMedia({
                    audio: true,
                    video: false,
                  })
                  .then((stream) => {
                    getMediaSuccess(stream);
                  })
                  .catch((e) => {
                    getMediaFail(e);
                  });
              } else {
                navigator.getUserMedia(
                  {
                    audio: true,
                    video: false,
                  },
                  (stream) => {
                    getMediaSuccess(stream);
                  },
                  function (e) {
                    getMediaFail(e);
                  }
                );
              }
            } else {
              console.log(2322);
              this.connectWebsocket();
            }
          } else {
            var isChrome = navigator.userAgent.toLowerCase().match(/chrome/);
            alert("暂不支持使用该浏览器,请使用chrome浏览器");
          }
        }

        stop() {
          this.state = "end";
          try {
            this.mediaStream.disconnect(this.recorder);
            this.recorder.disconnect();
          } catch (e) {}
        }

        sendData(buffer) {
          recorderWorker.postMessage({
            command: "transform",
            buffer: buffer,
          });
        }
        // 生成握手参数
        getHandShakeParams() {
          var appId = this.appId;
          var secretKey = this.apiKey;
          var ts = Math.floor(new Date().getTime() / 1000); //new Date().getTime()/1000+'';
          var signa = hex_md5(appId + ts); //hex_md5(encodeURIComponent(appId + ts));//EncryptUtil.HmacSHA1Encrypt(EncryptUtil.MD5(appId + ts), secretKey);
          var signatureSha = CryptoJSNew.HmacSHA1(signa, secretKey);
          var signature = CryptoJS.enc.Base64.stringify(signatureSha);
          signature = encodeURIComponent(signature);
          return (
            "?appid=" +
            appId +
            "&ts=" +
            ts +
            "&signa=" +
            signature +
            "&pd=court"
          );
        }
        connectWebsocket() {
          var url = "wss://rtasr.xfyun.cn/v1/ws";
          var urlParam = this.getHandShakeParams();

          url = `${url}${urlParam}`;
          if ("WebSocket" in window) {
            this.ws = new WebSocket(url);
          } else if ("MozWebSocket" in window) {
            this.ws = new MozWebSocket(url);
          } else {
            alert(notSupportTip);
            return null;
          }
          this.ws.onopen = (e) => {
            this.mediaStream.connect(this.recorder);
            this.recorder.connect(this.context.destination);
            setTimeout(() => {
              this.wsOpened(e);
            }, 500);
            this.config.onStart && this.config.onStart(e);
          };
          this.ws.onmessage = (e) => {
            // this.config.onMessage && this.config.onMessage(e)
            this.wsOnMessage(e);
          };
          this.ws.onerror = (e) => {
            this.stop();
            console.log("关闭连接ws.onerror");
            this.config.onError && this.config.onError(e);
          };
          this.ws.onclose = (e) => {
            this.stop();
            console.log("关闭连接ws.onclose");
            // $('.start-button').attr('disabled', false);
            this.config.onClose && this.config.onClose(e);
          };
        }

        wsOpened() {
          if (this.ws.readyState !== 1) {
            return;
          }
          var audioData = buffer.splice(0, 1280);
          this.ws.send(new Int8Array(audioData));
          this.handlerInterval = setInterval(() => {
            // websocket未连接
            if (this.ws.readyState !== 1) {
              clearInterval(this.handlerInterval);
              return;
            }
            if (buffer.length === 0) {
              if (this.state === "end") {
                this.ws.send('{"end": true}');
                clearInterval(this.handlerInterval);
              }
              return false;
            }
            var audioData = buffer.splice(0, 1280);
            if (audioData.length > 0) {
              this.ws.send(new Int8Array(audioData));
            }
          }, 40);
        }

        wsOnMessage(e) {
          let jsonData = JSON.parse(e.data);
          console.log(jsonData.action, "action");
          if (jsonData.action == "started") {
            // 握手成功
            console.log("握手成功");
          } else if (jsonData.action == "result") {
            // 转写结果
            if (
              this.config.onMessage &&
              typeof this.config.onMessage == "function"
            ) {
              this.config.onMessage(jsonData.data);
            }
          } else if (jsonData.action == "error") {
            // 连接发生错误
            console.log("出错了:", jsonData);
            // alert("连接发发生错误")
          }
        }

        ArrayBufferToBase64(buffer) {
          var binary = "";
          var bytes = new Uint8Array(buffer);
          var len = bytes.byteLength;
          for (var i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
          }
          return window.btoa(binary);
        }
      }

      class IatTaste {
        constructor() {
          var iatRecorder = new IatRecorder({
            onClose: () => {
              this.stop();
              this.reset();
            },
            onError: (data) => {
              this.stop();
              this.reset();
              alert("WebSocket连接失败");
            },
            onMessage: (message) => {
              this.setResult(JSON.parse(message));
            },
            onStart: () => {
              // this.counterDown(time)
            },
          });
          this.iatRecorder = iatRecorder;
          // this.counterDownDOM = time
          this.counterDownTime = 0;
        }

        start() {
          this.iatRecorder.start();
        }

        stop() {
          this.iatRecorder.stop();
        }

        reset() {
          this.counterDownTime = 0;
          clearTimeout(this.counterDownTimeout);
          buffer = [];
        }

        init() {
          let self = this;
          // let timer = null;
          //开始按钮的事件
          startBtn.onclick = function () {
            if (that.flags) {
              return;
            }
            console.log('创建timer',that.timer);
            that.timer=null
            that.timer = setInterval(() => {

              that.countdown--;
              if (that.countdown <= 0) {
                clearInterval(that.timer)
                self.stop();
                //reset
                this.counterDownTime = 0;
                clearTimeout(this.counterDownTimeout);
                buffer = [];
                that.flag = false;
                that.lodding=true
                that.flags = true;
                if (!that.content) {
                  return;
                }
                that.source()
              }
            }, 1000);
            if (navigator.getUserMedia && AudioContext && recorderWorker) {
              self.start();
              return false;
            } else {
              alert(notSupportTip);
            }
          };

          //结束按钮的事件
          endBtn.onclick = function () {
            clearInterval(that.timer)
            let container =
              document.querySelector(".rowy") ||
              document.querySelector(".main");
            let userTop = document.querySelectorAll(".right1");
            // container.scrollTop = container.scrollHeight + userTop[userTop.length - 1].scrollHeight;
            container.scrollTop = container.scrollHeight;

            // self.stop();
            //reset
            this.counterDownTime = 0;
            clearTimeout(this.counterDownTimeout);
            buffer = [];
 
          };
        }

        // 转写的结果
        setResult(data) {
          let rtasrResult = [];
          rtasrResult[data.seg_id] = data;
          rtasrResult.forEach((i) => {
            let str = "";
            if (i.cn.st.type == 0) {
              i.cn.st.rt.forEach((j) => {
                j.ws.forEach((k) => {
                  k.cw.forEach((l) => {
                    str += l.w;
                  });
                });
              });
              that.content += str;
              // output.innerText += str
            }
          });
        }

        // 计时器
        counterDown() {
          if (this.counterDownTime >= 0 && this.counterDownTime < 10) {
            this.counterDownDOM.innerText = "00: 0" + this.counterDownTime;
          } else if (this.counterDownTime >= 10 && this.counterDownTime < 60) {
            this.counterDownDOM.innerText = "00: " + this.counterDownTime;
          } else if (
            this.counterDownTime % 60 >= 0 &&
            this.counterDownTime % 60 < 10
          ) {
            this.counterDownDOM.innerText =
              "0" +
              parseInt(this.counterDownTime / 60) +
              ": 0" +
              (this.counterDownTime % 60);
          } else {
            this.counterDownDOM.innerText =
              "0" +
              parseInt(this.counterDownTime / 60) +
              ": " +
              (this.counterDownTime % 60);
          }
          this.counterDownTime++;
          this.counterDownTimeout = setTimeout(() => {
            this.counterDown();
          }, 1000);
        }
      }
      var iatTaste = new IatTaste();
      iatTaste.init();
    },
  },
};
